import { useState, useEffect, useContext } from "react";
import { useFormContext } from "react-hook-form";
import { environment } from "../global/environment";
import DataContext from "../contexts/DataContext";
import Select, { components } from "react-select";
import axios from "../api/axios";
import styles from "./BasicDataTab.module.css";

export function CurriculumVitaeDataTab() {
    const {
    register,
    setValue,
    getValues,
    formState: { errors },
  } = useFormContext();
  const { candidate } = useContext(DataContext);
  const uploadPhoto = {
    opacity: 0,
    position: "absolute",
    zIndex: -1,
  };

  const [curriculumVitae, setCurriculumVitae] = useState();
  const [uploadedCV, setUploadedCV] = useState();
  const [interestAreasOptions, setInterestAreasOptions] = useState([]);
  const [interestAreas, setInterestAreas] = useState([]);
  const [selectedInterestAreas, setSelectedInterestAreas] = useState([]);
  const [isInternalUser, setIsInternalUser] = useState(window.isInternalUser);

  const addCV = (file) => {
    setUploadedCV();
    setCurriculumVitae(file);
    setValue("cv", file);
  };

  useEffect(() => {
    if (candidate?.cvName) {
      setCurriculumVitae();
      setUploadedCV(candidate.cvName);
    }
  }, [candidate.cvName]);

  useEffect(() => {
    //Skip if internal user
    if(isInternalUser){ return; }

    axios.get(environment.interestAreasUri).then(
      (response) => {
        setInterestAreas(response.data._embedded.interest_areas);
      },
      () => {
        setInterestAreas([]);
      }
    );
  }, []);

  useEffect(() => {
    const options = interestAreas.map((item) => ({
      label: item.name,
      value: item.id,
      featured: item.featured,
    }));

    let selectedInterestAreas = [];
    // move the featured element to the first place in array
    if (getValues("interestAreas")) {
      selectedInterestAreas = getValues("interestAreas");
      const featuredIndex = selectedInterestAreas.findIndex(
        (item) => item.featured === 1
      );
      if (featuredIndex > -1) {
        const [featuredItem] = selectedInterestAreas.splice(featuredIndex, 1);
        selectedInterestAreas = [featuredItem, ...selectedInterestAreas];
      }

      // search the selected interested area into options
      const selected = selectedInterestAreas.map((item) => {
        const option = options.find(
          (opt) => opt.value === parseInt(item.interestArea)
        );
        return option || { value: item.interestArea, label: "" };
      });
      setSelectedInterestAreas(selected);
      setValue("interestAreas", selectedInterestAreas);
    }

    setInterestAreasOptions(options);
  }, [interestAreas]);

  const openFile = () => {
    axios.get(environment.downloadMyCVUri).then(
      (response) => {
        if (response.data["url"]) {
          window.open(response.data["url"], "_blank");
        }
      },
      () => {}
    );
  };

  const removeCV = () => {
    setValue("cv", null);
    setValue("cvName", null);
    setUploadedCV();
    setCurriculumVitae();
  };

    const Option = (props) => {
    return (
      <components.Option {...props}>
        {props.label}
        {props.data.featured && (
          <button className={[styles["c-star"], "u-tap-size"].join(" ")}>
            <svg
              className={[styles["c-star__svg"]].join(" ")}
              viewBox="0 0 488 465.81"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g fill="">
                <path d="m244 17.46 70 141.85 156.54 22.74-113.27 110.42 26.74 155.88-140.01-73.59-140.01 73.59 26.75-155.88-113.28-110.42 156.54-22.74z" />
                <path d="m384.01 465.81c-2.78 0-5.57-.66-8.12-2.01l-131.88-69.32-131.88 69.32c-5.88 3.09-13.01 2.58-18.39-1.33s-8.07-10.53-6.95-17.08l25.19-146.84-106.71-103.99c-4.76-4.64-6.47-11.58-4.42-17.9s7.52-10.93 14.1-11.88l147.45-21.43 65.94-133.62c2.94-5.96 9.01-9.73 15.66-9.73s12.72 3.77 15.66 9.73l65.94 133.61 147.45 21.43c6.58.96 12.04 5.56 14.1 11.88 2.05 6.32.34 13.26-4.42 17.9l-106.7 104 25.19 146.84c1.12 6.55-1.57 13.17-6.95 17.08-3.04 2.21-6.65 3.34-10.27 3.34zm-140.01-108.52c2.79 0 5.58.67 8.12 2l108.69 57.13-20.76-121.02c-.97-5.66.91-11.44 5.02-15.46l87.94-85.72-121.52-17.66c-5.69-.83-10.6-4.4-13.15-9.55l-54.34-110.11-54.34 110.11c-2.54 5.15-7.46 8.73-13.15 9.55l-121.52 17.66 87.94 85.72c4.12 4.01 5.99 9.79 5.02 15.46l-20.76 121.02 108.69-57.13c2.54-1.34 5.33-2.01 8.12-2.01z" />
              </g>
            </svg>
          </button>
        )}
      </components.Option>
    );
  };

  return (
    <div className="c-profile-info__switchable js-switchable" data-content="4">
      <h3 className="u-hidden-for-seo">Currículum Vitae</h3>

      {!isInternalUser && interestAreasOptions?.length > 0 && (
        <>
          <p className="c-profile-info__intro u-text"  style={{ marginBottom: '24px' }}>Indicar tus áreas de interés nos ayuda a filtrar mejor las oportunidades laborales que te mostraremos. Además, asegúrate de subir tu currículum actualizado para que podamos adjuntarlo a tus postulaciones.</p>
          <div className="c-profile-info__section c-form__section" style={{ marginBottom: '4rem' }}>
            <div className="c-form__row">
              <p className="c-form__text">
                Seleccione las áreas de interés
              </p>
              <label className="c-form__group">
                <Select
                  className={[
                    ["c-form__input"],
                    styles["c-form__input--select"],
                  ].join(" ")}
                  name="interest-areas"
                  id="interest-areas"
                  isMulti={true}
                  {...register("interestAreas")}
                  options={interestAreasOptions}
                  components={{ Option }}
                  defaultValue={selectedInterestAreas}
                  onChange={(event) => {
                    setValue(
                      "interestAreas",
                      event.map((area, index) => {
                        return {
                          interestArea: area.value,
                          featured: index === 0 ? 1 : 0,
                        };
                      })
                    );
                  }}
                ></Select>
              </label>
            </div>

            <div className="c-form-ro c-form__row--2col">
              <label className="c-form__group c-form__col" style={{width: '100%'}}>
                <p className="c-form__text">
                  Condición laboral actual
                </p>
                <span className="c-form__select">
                  <select
                    className="c-form__input"
                    name="c-form__col--small"
                    id="c-form__col--small"
                    defaultValue={"employmentStatus"}
                    {...register("employmentStatus", { required: true })}
                  >
                    <option value="select" disabled>
                      Seleccione una
                    </option>
                    <option value="working_and_searching">Trabajando a la actualidad y en búsqueda de nuevas oportunidades</option>
                    <option value="noworking_and_searching">No trabajando a la actualidad, en búsqueda activa de oportunidades.</option>
                  </select>
                </span>
                {errors.employmentStatus && errors.employmentStatus.type === "required" && (
                    <span className="c-form__error">Este campo es obligatorio</span>
                )}
              </label>
            </div>
          </div>
        </>
      )}

      {!curriculumVitae && !uploadedCV ? (
        <>
          <p className="c-form__text">
            Sube aquí tu currículum en formato PDF o Word.
          </p>
          <p className="c-form__hint">
            <span className="c-form__hint-icon icon-empty"></span>No tienes
            ningún archivo cargado en tu perfil.
          </p>
          {/* <!-- AÑADIR CV --> */}
          <button
            type="button"
            className="c-form__btn-add--xl u-separator"
            htmlFor="upload-cv"
          >
            <label htmlFor="upload-photo">
              <span
                className="c-form__btn-add-icon c-form__btn-add-icon--xl icon-more"
                htmlFor="upload-cv"
              ></span>
              Añadir currículum vitae
              <input
                type="file"
                name="photo"
                id="upload-photo"
                style={uploadPhoto}
                accept=".pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                onChange={(e) => addCV(e.target.files[0])}
              />
            </label>
          </button>
        </>
      ) : (
        <>
          {/* <!-- CV CARGADO --> */}
          <p className="c-form__text">
            El siguiente archivo se adjuntará a tus postulaciones:
          </p>
          <a
            className={
              "c-form__cv " + "u-primary-bg"
            }
            href="#"
          >
            <span className="c-form__cv-doc">
              <span className="c-form__cv-icon"></span>
              <span className="c-form__cv-name">
                {curriculumVitae ? curriculumVitae.name : candidate.cvName}
              </span>
            </span>
            {uploadedCV && (
              <div
                onClick={openFile}
                target="_blank"
                className="c-form__cv-download c-download__link u-tap-size"
              >
                Ver archivo
                <span className="c-download__link-icon icon-eye"></span>
              </div>
            )}
          </a>
          <div className="c-form__right-aligner">
            {/* <button type="button" className="c-form__btn c-form__btn-replace u-tap-size"> */}
            <label
              className="c-form__btn c-form__btn-replace u-tap-size"
              htmlFor="update-cv"
            >
              <span className="c-form__btn-icon icon-change"></span>Reemplazar
              archivo
              <input
                type="file"
                name="cv"
                id="update-cv"
                style={uploadPhoto}
                accept=".pdf,.doc,.docx"
                onChange={(e) => addCV(e.target.files[0])}
              />
            </label>
            {/* </button> */}
            <button
              onClick={removeCV}
              type="button"
              className="c-form__btn c-form__btn-delete u-tap-size"
            >
              <span className="c-form__btn-icon icon-delete"></span>Eliminar
            </button>
          </div>
        </>
      )}
    </div>
  );
}